// extracted by mini-css-extract-plugin
export default {"tag":"DemoArtistTag_tag__ak4jw"};